import AppRegistration from '@mui/icons-material/AppRegistration';
import Support from '@mui/icons-material/Support';
import Bookmarks from '@mui/icons-material/Bookmarks';
import Help from '@mui/icons-material/Help';
import Home from '@mui/icons-material/Home';
import Construction from '@mui/icons-material/Construction';
import Apps from '@mui/icons-material/Apps';
import Settings from '@mui/icons-material/Settings';
import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import Create from '@mui/icons-material/Create';

export const AppsMenuIcon = props => {
	return <Apps {...props} />;
};

export const AppInfoIcon = props => {
	return <AppRegistration {...props} />;
};

export const FavoritesMenuIcon = props => {
	return <Bookmarks {...props} />;
};

export const HelpMenuIcon = props => {
	return <Help {...props} />;
};

export const HomeMenuIcon = props => {
	return <Home {...props} />;
};

export const RequestMenuIcon = props => {
	return <Create {...props} />;
};

export const SettingsMenuIcon = props => {
	return <Settings {...props} />;
};

export const StaffMenuIcon = props => {
	return <SupervisorAccount {...props} />;
};

export const SupportMenuIcon = props => {
	return <Support {...props} />;
};

export const ToolsMenuIcon = props => {
	return <Construction {...props} />;
};